import { render } from "./EventSpeakers.vue?vue&type=template&id=5c755b04"
import script from "./EventSpeakers.vue?vue&type=script&lang=js"
export * from "./EventSpeakers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__